import { GridColDef, GridExpandMoreIcon } from "@mui/x-data-grid";

import { useQuery } from "@tanstack/react-query";
import {
  Accordion,
  AccordionSummary,
  GKClientDataGrid,
  Typography,
} from "components";
import axiosInstance from "utils/axiosInstance";
import { extraColumnsField } from "utils/helpers";

const UniqueBrokerCount = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["GET_UNIQUE_BROKER_COUNT"],
    queryFn: () => axiosInstance.get(`/super_admin/unique-broker-count/`),
  });

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("Broker", "broker", 150, 1),
      valueGetter: (params) => params.row.broker,
    },
    {
      ...extraColumnsField("Count", "count", 150, 1),
      valueGetter: (params) => params.row.count,
    },
  ];

  return (
    <>
      <Accordion
        disableGutters
        style={{
          border: `solid 1px var(--neutral-100)`,
          borderRadius: "8px",
          boxShadow: "none",
          background: "none",
        }}
      >
        <AccordionSummary
          expandIcon={<GridExpandMoreIcon />}
          sx={{
            "& .MuiAccordionSummary-content": {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            },
          }}
        >
          <Typography
            fontSize={16}
            fontWeight={600}
            textTransform={"none"}
            color={"var(--primary-900)"}
          >
            Broker Count
          </Typography>
        </AccordionSummary>
        <GKClientDataGrid
          loading={isLoading}
          columns={columns}
          rows={data?.data?.data}
          showFiltersButton={false}
        />
      </Accordion>
    </>
  );
};

export default UniqueBrokerCount;
